import {useState, useRef, useEffect} from "react";
import {useClickAway} from "react-use";
import {createPortal} from "react-dom";
import s from './Popup.module.css';
import classNames from "classnames";
import {CloseIcon} from "@/utils/icons";
import {useInputNew} from "@UI/InputNew/useInputNew";
import * as InputNew from "@UI/InputNew/Input";
import ProgressBar from "@UI/ProgressBar";
import { useConvertInDataUrl } from '@/hooks/useConvertInDataUrl'
const Popup = ({
   header,
   closeCallback,
   setAction,
   file,
   setFile,
//    setImage,
   action,
   updateFile = false,
   uploading = false,
   progress = 0,
   isVisiblePopup,
   moreButton,
   textButtom = 'Да',
}) => {
    const [isClosePopup, setIsClosePopup] = useState(false);
    const modalRef = useRef(null);
    const [bindFile] = useInputNew({
        name: 'file',
        value: file,
        onChange: (e) => setFile(e),
    });

    useClickAway(modalRef, () => {
        if (isVisiblePopup && !isClosePopup) {
            handleClose();
        }
    });

    const {dataUrl: imagePreview} = useConvertInDataUrl({file})

    const handleClose = () => {
        setIsClosePopup(true);
        setTimeout(() => {
            closeCallback(false);
            setIsClosePopup(false);
        }, 300);
    };

    // Если не должно рендериться, возвращаем null
    if (!isVisiblePopup) {
        return <></>;
    }

    return createPortal(
        <>
            <div className={classNames(s.blur, { [s.blurOut]: isClosePopup })} />
            <div className={s.popupWrapper}>
                <div ref={modalRef} className={classNames(s.popup, {[s.popupOut]: isClosePopup})}>
                    <div className={s.popupHeader}>
                       <span dangerouslySetInnerHTML={{__html: header}}/>
                        <button className={s.close} type="button" onClick={handleClose}>
                            <CloseIcon width={'24'} height={'24'}/>
                        </button>
                    </div>

                    {imagePreview && (
                        <div className={s.imagePreview}>
                            <img src={imagePreview} alt="Preview" />
                        </div>
                    )}

                    {updateFile && !uploading && (
                      <div className={s.childrenWrapper}>
                          <InputNew.InputFileNewDesign
                            className={s.inputFile}
                            {...bindFile}
                            placeholder={'Выбрать файл'}
                            newDesign
                            isCameraIcon={true}
                          />
                      </div>
                    )}

                    {uploading && (
                        <>
                            <h3 className={s.modalMessage}>Подождите, идет сохранение данных</h3>
                            <ProgressBar value={progress}/>
                        </>
                    )}
                    <div className={s.actions}>
                      {
                        !!moreButton && moreButton
                      }
                      {!uploading &&
                        <button type={'button'} className={s.btn} onClick={() => setAction(true)}>
                          {textButtom}
                        </button>
                      }

                      <button type={'button'} className={s.btn} onClick={handleClose}>Отмена</button>
                    </div>
                </div>
            </div>
        </>,
      document.body
    );
}

export default Popup;